import ConsentManagerStep from './ConsentManagerStep';

export default ConsentManagerStep;
